/* Smooth scroll for TOC links */
document.addEventListener('click', function(e) {
  const a = e.target.closest('a[href^="#"]');
  if (a) {
    e.preventDefault();
    const id = a.getAttribute('href').slice(1);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});


// FAQ js----------------------------------------------------------------------------------------------
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');

  document.querySelectorAll('.faq-item').forEach(i => {
      i.classList.remove('open');
  });

  if (!isOpen) {
      item.classList.add('open');
  }
}

document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => toggleFaq(btn));
});




// Produc js----------------------------------------------------------------------------------------------

// Product variants (works with AJAX-loaded collection tabs)

// document.addEventListener('DOMContentLoaded', function () {

//   // Default variant selection
//   function initVariantCards(scope = document) {
//     scope.querySelectorAll('.product-card-wrapper').forEach((card) => {
//       const variantCards = card.querySelectorAll('.variant-card');

//       if (!variantCards.length) return;

//       // Prevent re-initialization
//       if (card.dataset.variantInitialized) return;
//       card.dataset.variantInitialized = 'true';

//       if (variantCards.length > 1) {
//         variantCards[1].click();
//       } else {
//         variantCards[0].click();
//       }
//     });
//   }

//   // Initial page load
//   initVariantCards();

//   // Event delegation for variant clicks
//   document.addEventListener('click', function (e) {
//     const variantCard = e.target.closest('.variant-card');

//     if (!variantCard) return;

//     const card = variantCard.closest('.product-card-wrapper');

//     if (!card) return;

//     const variantCards = card.querySelectorAll('.variant-card');
//     const hiddenInput = card.querySelector('.selected-variant-id');
//     const priceEl = card.querySelector('.product-price');
//     const dynamicPrice = card.querySelector('.dynamic-price');
//     const comparePrice = card.querySelector('.dynamic-compare-price');
//     const discountEl = card.querySelector('.product-discount');

//     variantCards.forEach((c) => c.classList.remove('active'));
//     variantCard.classList.add('active');

//     const variantId = variantCard.dataset.variantId;
//     const newPrice = variantCard.dataset.price;
//     const newCompare = variantCard.dataset.comparePrice;

//     const priceCents =
//       parseInt(variantCard.dataset.priceCents, 10) || 0;

//     const comparePriceCents =
//       parseInt(variantCard.dataset.comparePriceCents, 10) || 0;

//     if (hiddenInput) {
//       hiddenInput.value = variantId;
//     }

//     if (priceEl && newPrice) {
//       priceEl.textContent = newPrice;
//     }

//     if (dynamicPrice && newPrice) {
//       dynamicPrice.textContent = newPrice;
//     }

//     if (comparePrice) {
//       if (comparePriceCents > priceCents) {
//         comparePrice.textContent = `was ${newCompare}`;
//         comparePrice.style.display = 'block';
//       } else {
//         comparePrice.style.display = 'none';
//       }
//     }

//     if (discountEl) {
//       if (comparePriceCents > priceCents) {
//         const discount = Math.round(
//           ((comparePriceCents - priceCents) / comparePriceCents) * 100
//         );

//         discountEl.textContent = `${discount}% off`;
//         discountEl.style.display = 'inline-flex';
//       } else {
//         discountEl.style.display = 'none';
//       }
//     }
//   });

//   // Reinitialize variants after collection tab AJAX load
//   const observer = new MutationObserver(function (mutations) {
//     mutations.forEach((mutation) => {
//       if (mutation.addedNodes.length) {
//         initVariantCards();
//       }
//     });
//   });

//   const productGridContainer = document.getElementById('ProductGridContainer');

//   if (productGridContainer) {
//     observer.observe(productGridContainer, {
//       childList: true,
//       subtree: true,
//     });
//   }
// });




document.addEventListener('DOMContentLoaded', function () {

  // ===============================
  // CORE: Update Variant UI
  // ===============================
  function updateVariantUI(card, variantCard) {
    const variantCards = card.querySelectorAll('.variant-card');
    const hiddenInput = card.querySelector('.selected-variant-id');
    const priceEl = card.querySelector('.product-price');
    const dynamicPrice = card.querySelector('.dynamic-price');
    const comparePrice = card.querySelector('.dynamic-compare-price');
    const discountEl = card.querySelector('.product-discount');

    variantCards.forEach((c) => c.classList.remove('active'));
    variantCard.classList.add('active');

    const variantId = variantCard.dataset.variantId;
    const newPrice = variantCard.dataset.price;
    const newCompare = variantCard.dataset.comparePrice;

    const priceCents = parseInt(variantCard.dataset.priceCents, 10) || 0;
    const comparePriceCents = parseInt(variantCard.dataset.comparePriceCents, 10) || 0;

    if (hiddenInput) {
      hiddenInput.value = variantId;
    }

    if (priceEl && newPrice) {
      priceEl.textContent = newPrice;
    }

    if (dynamicPrice && newPrice) {
      dynamicPrice.textContent = newPrice;
    }

    if (comparePrice) {
      if (comparePriceCents > priceCents) {
        comparePrice.textContent = `was ${newCompare}`;
        comparePrice.style.display = 'block';
      } else {
        comparePrice.style.display = 'none';
      }
    }

    if (discountEl) {
      if (comparePriceCents > priceCents) {
        const discount = Math.round(
          ((comparePriceCents - priceCents) / comparePriceCents) * 100
        );
        discountEl.textContent = `${discount}% off`;
        discountEl.style.display = 'inline-flex';
      } else {
        discountEl.style.display = 'none';
      }
    }
  }

  // ===============================
  // INIT DEFAULT VARIANT
  // ===============================
  function initVariantCards(scope = document) {
    scope.querySelectorAll('.product-card-wrapper').forEach((card) => {

      const variantCards = card.querySelectorAll('.variant-card');
      if (!variantCards.length) return;

      if (card.dataset.variantInitialized) return;
      card.dataset.variantInitialized = 'true';

      // Default: 2nd variant if exists else 1st
      const defaultVariant = variantCards.length > 1
        ? variantCards[1]
        : variantCards[0];

      if (defaultVariant) {
        updateVariantUI(card, defaultVariant);
      }
    });
  }

  // ===============================
  // INITIAL LOAD
  // ===============================
  initVariantCards();

  // ===============================
  // CLICK HANDLER (DELEGATION)
  // ===============================
  document.addEventListener('click', function (e) {
    const variantCard = e.target.closest('.variant-card');
    if (!variantCard) return;

    const card = variantCard.closest('.product-card-wrapper');
    if (!card) return;

    updateVariantUI(card, variantCard);
  });

  // ===============================
  // HANDLE AJAX / DYNAMIC LOAD
  // ===============================
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        initVariantCards();
      }
    }
  });

  const productGridContainer = document.getElementById('ProductGridContainer');

  if (productGridContainer) {
    observer.observe(productGridContainer, {
      childList: true,
      subtree: true,
    });
  }

});




const buttons = document.querySelectorAll('.shakeXButton');
  function toggleShake() {
    buttons.forEach(button => {
      button.classList.add('shakeX', 'slow');
      setTimeout(() => {
        button.classList.remove('shakeX', 'slow');
      }, 600); 
    });
  }
setInterval(toggleShake, 8000);
toggleShake();